import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import "./paymentpayhere.scss"
function PayhereCancel() {
  const navigate =useNavigate()
    useEffect(() => {
      const timer = setTimeout(() => {
       navigate("/");
      }, 5000);
  
      return () => clearTimeout(timer);
    }, []);
  return (
    <div className="pyment_cancelled">
      <h1>Payment cancelled</h1>
      <button onClick={()=>navigate("/")}>got to dashboard</button>
    </div>
  )
}

export default PayhereCancel